/**
 * Schemas of the reference datasets under refdata/ (Technical Specifications, section 9.1).
 */
import { z } from 'zod';
const bool = z.union([z.literal('true'), z.literal('false')]).transform((v) => v === 'true');
const csvInt = z.string().regex(/^\d+$/).transform(Number);
export const cmdRowSchema = z
    .object({
    code: z.string().regex(/^\d{2}( \d{2}){0,2}$/),
    level: csvInt.pipe(z.union([z.literal(1), z.literal(2), z.literal(3)])),
    label_fr: z.string().min(3),
    label_ar: z.string().optional(),
    is_hazardous: bool,
    parent: z.string().transform((v) => (v === '' ? null : v)),
})
    .refine((r) => r.code.split(' ').length === r.level, { message: 'level must match the code' })
    .refine((r) => r.level === 1 ? r.parent === null : r.parent === r.code.split(' ').slice(0, -1).join(' '), {
    message: 'parent must be the code without its last pair',
})
    .refine((r) => !r.is_hazardous || r.level === 3, { message: 'only entries can be hazardous' });
export const drRowSchema = z.object({
    code: z.string().regex(/^[DR]\d{1,2}$/),
    family: z.enum(['ELIMINATION', 'VALORISATION']),
    label_fr: z.string().min(3),
    label_en: z.string().min(3),
});
export const hazardPropertyRowSchema = z.object({
    code: z.string().regex(/^H\d{1,2}(-[A-C])?$/),
    label_fr: z.string().min(3),
    hp_mapping: z.string().regex(/^HP\d{1,2}$/),
    definition_fr: z.string().min(10),
});
const emptyAsNull = z.string().transform((v) => (v === '' ? null : v));
const list = z.string().transform((v) => (v === '' ? [] : v.split(';').map((l) => l.trim())));
/**
 * A line of ADR table A. The starter table has the first columns only; the full table read from
 * the UNECE edition adds its position, descriptions, limited and excepted quantities, hazard
 * number, carriage status and the other columns as printed.
 */
export const adrRowSchema = z.object({
    un_number: z.string().regex(/^\d{4}$/),
    proper_shipping_name: z.string().min(3),
    class_code: z.string().min(1),
    classification_code: emptyAsNull,
    packing_group: z.enum(['I', 'II', 'III', '']).transform((v) => (v === '' ? null : v)),
    labels: list,
    tunnel_code: z.string().transform((v) => (v === '' || v === '-' ? null : v)),
    /** Empty for the entries without a category ("-" in column 15) and those not carried. */
    transport_category: z
        .string()
        .transform((v) => (v === '' ? null : Number(v)))
        .pipe(z.number().int().min(0).max(4).nullable()),
    requires_technical_name: bool,
    seq: z.string().regex(/^\d+$/).transform(Number).optional(),
    proper_shipping_name_en: emptyAsNull.optional(),
    description: emptyAsNull.optional(),
    description_en: emptyAsNull.optional(),
    special_provisions: list.optional(),
    limited_quantity: emptyAsNull.optional(),
    excepted_quantity: emptyAsNull.optional(),
    hazard_id: emptyAsNull.optional(),
    carriage: z.enum(['ALLOWED', 'PROHIBITED', 'NOT_SUBJECT']).default('ALLOWED'),
    columns: z
        .string()
        .transform((v) => JSON.parse(v || '{}'))
        .optional(),
});
export const REF_DATASETS = ['CMD', 'DR', 'HAZARD_PROPERTIES', 'ADR'];
//# sourceMappingURL=refdata.js.map